export const visit = (vm, at) => {
vm(require("pricing-pages-ui/lang/ja.lyaml"));
vm(require("feature-monetization/lang/ja.lyaml"));
vm(require("usage-based-billing-components-lib/lang/CreditEstimator/ja.lyaml"));
vm(require("usage-based-billing-components-lib/lang/ja.lyaml"));
at({ "ja": { "publicPricingPage": { "windowTitles": { "default": "\u4FA1\u683C\u8868 | HubSpot" } } } });
};